angular.module('zc.zenclerkS')
  .component('zcsMenuSetup', {
    templateUrl: '/templates/zenclerk_s/layout/menu_setup.html',
    controllerAs: 'vm',
    controller: zcsMenuSetup,
  });

zcsMenuSetup.$inject = ['$scope', '$state', '$stateParams', 'Devise', 'ZcsProject'];
function zcsMenuSetup($scope, $state, $stateParams, Devise, ZcsProject) {
  const vm = this;
  vm.project = {};
  vm.$stateParams = $stateParams;
  vm.apikey = $stateParams.apikey;

  // TODO: make directive
  vm.isActive = isActive;

  $scope.$watch('vm.$stateParams', function(newval) {
    if(!newval || !newval.apikey) {
      return;
    }
    Devise.getCurrentUser()
      .then(currentUser => ZcsProject.get(currentUser.id, newval.apikey))
      .then(function(res) {
        vm.project = res;
        vm.project.url_clean = res.base_url.replace(/((http|https):\/\/)/g, '').replace(/\//g, '');
      });
    vm.apikey = newval.apikey;
  }
    , true);

  function isActive(category) {
    if(_.get($state.current, 'data.category') === category) {
      return true;
    }
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/layout/menu_setup.directive.js